export default __webpack_public_path__ + "static/media/Logo Diya.21d6bf04.png";